'use client';

var translation = {
    'Just removed 1 save job': 'Bạn vừa xóa 1 công việc',
    'You have saved job, view': 'Bạn đã lưu việc làm thành công, xem ',
    'My jobs': 'Việc làm của tôi',
    'Job Description': 'Mô tả công việc',
    'Job Requirements': 'Yêu cầu công việc',
    'View detail': 'Xem chi tiết',
    Applied: 'Đã Nộp Đơn',
    'Apply Now': 'Nộp Đơn',
    Success: 'Thành công',
    '/my-career-center/my-jobs?section=saved': '/quan-ly-nghe-nghiep/viec-lam-cua-toi?section=saved',
    'Accept invitation': 'Chấp nhận lời mời',
    'Employer has sent you an invitation.': 'Nhà tuyển dụng đã gửi lời mời ứng tuyển.'
};

export { translation as default };
//# sourceMappingURL=translation.js.map
